export const toQueryParams = (obj: any) => {
    return new URLSearchParams(obj).toString();
}

export const convertUrlSearchParamsToObject = (searchParams: URLSearchParams): any => {
    const obj = {};
    for (const [key, value] of searchParams.entries()) {
        obj[key] = value;
    }
    return obj;
}